import React from 'react';
import { getInputLabel } from "../../helper";

export function RiskPlan({
  conf: {
    input,
    values
  }
}) {
  const colors = {
    5: '207, 19, 34',
    4: '255, 77, 79',
    3: '250, 140, 22',
    2: '250, 219, 20',
    1: '115, 209, 61',
    0: '243, 243, 243',
  };
  const score = (values.assessment || {}).vulnerability || 0;
  const color = colors[score] || colors[0];
  return <div className="risk-plan" style={{
    background: `rgb(${color}, 0.1)`,
    borderColor: `rgb(${color}, 0.3)`,
  }}>
    <div className="subScore">
      <div className="levels">
        {[...Array(5)].map((level, index) => (
          <div style={{
            background: (index + 1) <= (values.assessment || {}).vulnerability
              ? `rgb(${color})` : '#f3f3f3'
          }}></div>
        ))}
      </div>
    </div>
    <div>
      {getInputLabel(input, values)}
    </div>
  </div>
}